import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import {
  styled,
  Typography,
} from '@mui/material';
import { AdvancedAnalysisItemType } from '../../generated/core-api/graphql-react-query';
import { purple, spaceCadet } from '../../utils/colors';

const StyledTypography = styled(Typography)({
  margin: 0,
  fontSize: 10,
  borderRadius: 4,
  lineHeight: '16px',
  padding: '2px 8px',
  fontWeight: 600,
  textTransform: 'uppercase',
  display: 'flex',
  gap: 4,
  alignItems: 'center',

  // Single-line ellipsis behavior is applied to the inner .label (see below)
  maxWidth: 300,
  cursor: 'default',

  '&.Default': {
    backgroundColor: spaceCadet[500],
    color: 'white',
    '& > div': {
      color: spaceCadet[500],
    },
  },
  [`&.${AdvancedAnalysisItemType.Compliance}`]: {
    backgroundColor: spaceCadet[500],
    color: 'white',
    '& > div': {
      color: spaceCadet[500],
    },
  },
  [`&.${AdvancedAnalysisItemType.Quality}`]: {
    backgroundColor: spaceCadet[500],
    color: 'white',
    '& > div': {
      color: spaceCadet[500],
    },
  },
  [`&.${AdvancedAnalysisItemType.CustomerInsights}`]: {
    backgroundColor: purple[500],
    color: 'white',
    '& > div': {
      color: purple[500],
    },
  },
  '& > div': {
    display: 'flex',
    margin: '-2px 0px -2px -8px',
    backgroundColor: 'white',
    borderRadius: '2px 0px 0px 2px',
    padding: '4px 4px',
    gap: 2,

  },
  '& svg': {
    display: 'block',
    fontSize: 12,
    flex: '0 0 auto', // icon should not shrink
  },

  '& .label': {
    minWidth: 0, // allow label to shrink
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1 1 auto', // take remaining space next to the icon
  },
});

export default function AdvancedAnalysisItemTag(props: { displayText: string, type?: AdvancedAnalysisItemType | null }) {
  const { displayText, type } = props;

  return (
    <StyledTypography className={type ?? 'Default'} title={displayText}>
      <PrecisionManufacturingIcon />
      <span className="label">{displayText}</span>
    </StyledTypography>
  );
}
